export default __webpack_public_path__ + "static/media/makenft.af9440fc.gif";